import useFetch from "./hooks/useFetch";
import FetchProvider from "./provider";
export type { IStatus, ICacheStrategy } from "./type";
export { FetchProvider };
export * from "./utils";
export default useFetch;
